import React from 'react';
import { Result, Button } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { userPath } from '../../shared/config/paths';
import { useTranslation } from '../../shared/i18n';

/**
 * 未开售产品的占位页（如事务邮件 TM：产品已下架，官网显示 "Coming soon"）。
 * 直接访问旧路由时展示，而不是可购买的套餐页。
 */
const ComingSoon = ({ title = '该产品', description }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Result
            icon={<ClockCircleOutlined style={{ color: 'var(--ant-color-primary, #2357ff)' }} />}
            title={t('{{title}} coming soon', { title: t(title) })}
            subTitle={t(description || '我们正在准备这项服务，上线后会第一时间通知您。')}
            extra={<Button type="primary" onClick={() => navigate(userPath('/dashboard'))}>{t('Back to overview')}</Button>}
        />
    );
};

export default ComingSoon;
